// Utilities
import CreditCard from '../../utility/creditCardUtil'

import { defaultObj } from './state'

export default {
  getPayCardTypesSuccess (state, cardTypeData) {
    if (cardTypeData.cardTypes) {
      state.cardTypes = cardTypeData.cardTypes
    }

    if (cardTypeData.bridgePayCardTypes) {
      state.bridgePayCardTypes = cardTypeData.bridgePayCardTypes
    }
  },

  getPayDebitCardsSuccess (state, cardsData) {
    state.paymentCards = cardsData.cards
    if (cardsData.validations) {
      state.validations = cardsData.validations
    }
  },

  addPayDebitCardSuccess (state, cardData) {
    state.paymentCards.push({
      cardIds: cardData.cardIds,
      cardNumber: cardData.cardNumber,
      cardType: cardData.cardType,
      cardholderName: cardData.cardholderName,
      customerId: cardData.customerId,
      customerIds: cardData.customerIds,
      expirationMonth: cardData.expirationMonth,
      expirationYear: cardData.expirationYear,
      guestCard: cardData.guestCard,
      newCard: cardData.newCard
    })
  },

  removePayDebitCardSuccess (state, cardsData) {
    state.paymentCards = state.paymentCards.filter(card => {
      return CreditCard.isSameCard(cardsData.cardIds, card.cardIds) === false
    })
  },

  setDisburseCards (state, cardsData) {
    state.disburseCards = cardsData.cards
    state.disburseValidations = cardsData.validations
  },

  removeDisburseCards (state, cardId) {
    state.disburseCards = state.disburseCards.filter(card => card.cardId !== cardId)
  },

  setTokenPayInstance (state, tokenPayInstance) {
    state.tokenPayInstance = tokenPayInstance
  },

  setTempBridgePayToken (state, tempToken) {
    state.bridgePayToken = tempToken
  },

  setTempDisburseBridgePayToken (state, tempToken) {
    state.bridgePayDisburseToken = tempToken
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
